enum ContentType {
    JSON = 'application/json',
    XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    PDF = 'application/pdf',
    DOC = 'application/msword',
}

export default ContentType;